import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { GroupSignature } from '@design-system/group-signature';
import { __ } from '@design-system/i18n';
import { styled } from 'styled-components';
export const GroupAndContentType = ({ group, type, }) => (_jsx(Box, { mb: 2, children: _jsxs(Box, { children: [group && (_jsx(GroupSignature, { groupName: group.name, logoSrc: group.logoSrc })), _jsxs(Box, { alignItems: "center", children: [group && type && _jsx(SpanWrapper, { children: "\u00B7" }), type && (_jsx(Box, { "aria-label": __(`Type of content: ${type}`), color: "primary", font: "metadata-semibold-asphalt", children: type }))] })] }) }));
const SpanWrapper = styled.span `
  margin: 0 ${({ theme }) => theme.space[1]}px;
`;
//# sourceMappingURL=GroupAndContentType.js.map